import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMoon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M22.8 6.4A12 12 0 1 0 22.8 29.6 9.6 9.6 0 1 1 22.8 6.4Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgMoon;
